module.exports = __webpack_public_path__ + "static/media/info-icon-white.d7df32ad.svg";